export default {
	biocatchEndpoint: {
		scoreUri: 'paas-base-url:/ibapi/v2/banks/:bankId/analyticsCYBG/score',
		apiVersion: '1.0.0',
		method: 'POST',
		getResolvedURI(uri, bankId, apiBaseUrl, apiBaseUrlPaas) {
			let endpoint =
				uri.indexOf('paas-base-url:') === 0 ? uri.replace('paas-base-url:', apiBaseUrlPaas) : apiBaseUrl + uri;
			endpoint = endpoint.replace(':bankId', bankId);
			return endpoint;
		},
		getBiocatchHeaders(clientContext, token) {
			return {
				'x-bpi-version': '1.0.0',
				'x-bpi-service-context': 'USER',
				'x-bpi-client-context': process.env.NODE_ENV === 'development' ? JSON.stringify(clientContext) : clientContext,
				'X-TS-AJAX-Request': true,
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
				Accept: 'application/json',
			};
		},
	},
};
